window.ReportingManagementAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['ReportingManagementV1']);

    self.getReportsFilters = function (brandId, params) {

        if (!brandId) {
            throw 'brandId is required';
        }
        var defer = $q.defer();

        var url = 'brands/' + brandId + '/reports';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getTopNavigationMenu = function (groupId, brandId, params) {
        if (!groupId) {
            throw 'groupId is required';
        }
        if (!brandId) {
            throw 'brandId is required';
        }
        var defer = $q.defer();

        var url = 'brands/' + groupId + '/top_navigation_menu/' + brandId;

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.createReportFilters = function (brandId, payload) {
        if (!brandId) {
            throw 'brandId is required';
        }
        var defer = $q.defer();

        var url = 'brands/' + brandId + '/reports';

        _protected.request(url, 'POST', payload)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.setReportFilters = function (brandId, reportCode, payload) {
        if (!brandId) {
            throw 'brandId is required';
        }
        var defer = $q.defer();

        var url = 'brands/' + brandId + '/reports/' + reportCode;

        _protected.request(url, 'PUT', payload)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.setTopNavigationMenu = function (groupId, brandId, payload) {
        if (!brandId) {
            throw 'brandId is required';
        }
        var defer = $q.defer();

        var url = 'brands/' + groupId + '/top_navigation_menu/' + brandId;

        _protected.request(url, 'PUT', payload)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.deleteReportFilters = function (brandId, reportCode, params) {
        if (!brandId) {
            throw 'brandId is required';
        }
        var defer = $q.defer();

        var url = 'brands/' + brandId + '/reports/' + reportCode;

        _protected.request(url, 'DELETE', params)
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getReportsServiceSettings = cacheService.cache(function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/reports/settings', 'GET')
            .then(function (res) {
                if (res.data && res.status === 200) {
                    for (var i in res.data.reports) {
                        var report = res.data.reports[i];

                        if (report.code === "FORECAST_ACCURACY_REPORT" && report.settings_meta) {
                            report.settings = JSON.parse(report.settings_meta);
                        }
                    }

                    defer.resolve(res.data);
                }
            })
            .catch(function (err) {
                console.error(err);
                defer.reject(err);
            });

        return defer.promise;
    })[0];

    const [getBrandReportsSettings, resetBrandReportsSettings] = cacheService.cache(function (brandId) {
        var defer = $q.defer();
        if (!brandId) {
            throw 'brandId is required';
        }
        _protected.request('brands/' + brandId + '/report_settings', 'GET')
            .then(function (response) {
                if (response.data && response.status === 200) {
                    if (response.data.report_settings) {
                        response.data.report_settings.apply_disclaimer_to_all_pages = true;
                    }
                    defer.resolve(response.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    });

    self.getBrandReportsSettings = getBrandReportsSettings;

    self.updateBrandReportsSettings = function (brandId, payload) {
        var defer = $q.defer();
        if (!brandId) {
            throw 'brandId is required';
        }
        _protected.request('brands/' + brandId + '/report_settings', 'PUT', payload)
            .then(function (response) {
                if (response.data && response.status === 200) {
                    resetBrandReportsSettings();
                    defer.resolve(response.data);
                } else {
                    defer.reject(response);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.hasPermissionOnBrandOrAnyChild = async (brandId, permissionCode, permissionCategory, oneOfPermissions = []) => {
        const params = {
            required_permissions: permissionCode,
            permission_category: permissionCategory,
            one_of_permissions: oneOfPermissions
        };

        const response = await _protected.request(`brands/${brandId}/permissions/is_authorized`, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getReportViews = async (brandId, reportCode, viewType, requestedFrom) => {
        const url = `brands/${brandId}/views/${reportCode}/all_views`;
        const params = {};

        if (viewType) {
            params.view_type = viewType;
        }

        if (requestedFrom) {
            params.requested_from = requestedFrom;
        }

        const response = await _protected.request(url, 'GET', params);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.createReportView = async (brandId, reportCode, payload) => {
        const url = `brands/${brandId}/views/${reportCode}`;
        const response = await _protected.request(url, 'POST', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.updateReportView = async (brandId, viewId, payload) => {
        const url = `brands/${brandId}/views/${viewId}`;
        const response = await _protected.request(url, 'PUT', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.deleteReportView = async (brandId, viewId) => {
        const url = `brands/${brandId}/views/${viewId}`;
        const response = await _protected.request(url, 'DELETE');

        if (response?.status === 200) {
            return response;
        }

        throw response;
    };

    self.setAsDefault = async (brandId, reportCode, viewId) => {
        const url = `brands/${brandId}/views/${reportCode}/set_default/${viewId}`;
        const response = await _protected.request(url, 'PUT');

        if (response?.status === 200) {
            return response;
        }

        throw response;
    };

    self.backToDefault = async (brandId, reportCode) => {
        const url = `brands/${brandId}/views/${reportCode}/back_to_system_default`;
        const response = await _protected.request(url, 'PUT');

        if (response?.status === 200) {
            return response;
        }

        throw response;
    };

    self.createReportView = async (brandId, reportCode, payload) => {
        const url = `brands/${brandId}/views/${reportCode}`;
        const response = await _protected.request(url, 'POST', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.updateReportView = async (brandId, viewId, payload) => {
        const url = `brands/${brandId}/views/${viewId}`;
        const response = await _protected.request(url, 'PUT', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.deleteReportView = async (brandId, viewId) => {
        const url = `brands/${brandId}/views/${viewId}`;
        const response = await _protected.request(url, 'DELETE');

        if (response?.status === 200) {
            return response;
        }

        throw response;
    };

    self.setAsDefault = async (brandId, reportCode, viewId) => {
        const url = `brands/${brandId}/views/${reportCode}/set_default/${viewId}`;
        const response = await _protected.request(url, 'PUT');

        if (response?.status === 200) {
            return response;
        }

        throw response;
    };

    self.backToDefault = async (brandId, reportCode) => {
        const url = `brands/${brandId}/views/${reportCode}/back_to_system_default`;
        const response = await _protected.request(url, 'PUT');

        if (response?.status === 200) {
            return response;
        }

        throw response;
    };

    self.getAvailableReports = async (brandId) => {
        const url = `brands/${brandId}/views/report_views_lookup`;
        const response = await _protected.request(url, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getServiceSettings = async (brandId, serviceCode) => {
        const response = await _protected.request(`brands/${brandId}/${serviceCode}/reporting_settings`, 'GET');


         if (response?.status === 200 && response?.data?.data) {
             return response.data.data;
         }

        throw response;
    };

});
